/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Workshopstatus1Inputs */

const de__field_workshopstatus1 = /** @type {(inputs: _Field_Workshopstatus1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veranstaltung Status`)
};

/**

* @param {_Field_Workshopstatus1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_workshopstatus1 = /** @type {((inputs?: _Field_Workshopstatus1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Workshopstatus1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_workshopstatus1(inputs)
});
export { _field_workshopstatus1 as "_field_workshopStatus" }